import { render, staticRenderFns } from "./manage-booking-modal-email-receipt.vue?vue&type=template&id=127f8e9c&scoped=true"
import script from "./manage-booking-modal-email-receipt.vue?vue&type=script&lang=ts"
export * from "./manage-booking-modal-email-receipt.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-modal-email-receipt.vue?vue&type=style&index=0&id=127f8e9c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f8e9c",
  null
  
)

export default component.exports